<template>
  <div>
    <div class="page_title">
      <custom-breadcrumb/>
    </div>
    <div class="order">
      <el-card shadow="none">
        <div class="order-header">
          <div class="order-header-item">
            <span class="gray">Order Total</span>
            <span v-if="dataInfo.batchInfoDetail.payAmount">${{ dataInfo.batchInfoDetail.payAmount }}</span>
          </div>
          <div class="border"/>
          <div class="order-header-item">
            <span class="gray">Order Date</span>
            <span>{{ dataInfo.batchInfoDetail.dateStr }}</span>
          </div>
          <div class="border"/>
          <div class="order-header-item">
            <span class="gray">Order Status</span>
            <span>{{ dataInfo.batchInfoDetail.batchStatusEnName }}</span>
          </div>
          <div class="border"/>
          <div class="order-header-item address">
            <span>{{ dataInfo.batchInfoDetail.name }} {{ dataInfo.batchInfoDetail.lastname }}</span>
            <span>{{ dataInfo.batchInfoDetail.address }}</span>
            <span>{{ dataInfo.batchInfoDetail.city }}, {{
                dataInfo.batchInfoDetail.province
              }}, {{ dataInfo.batchInfoDetail.countryName }}&nbsp;&nbsp;{{ dataInfo.batchInfoDetail.postCode }}</span>
            <span> {{ dataInfo.batchInfoDetail.areaCode }}{{ dataInfo.batchInfoDetail.phone }}</span>
          </div>
          <div class="border"/>
          <div class="order-header-item">
            <span class="gray">Customer</span>
            <span>{{ dataInfo.spSupplierRetailer ? dataInfo.spSupplierRetailer.retailerUserEmail : '' }}</span>
          </div>
        </div>
      </el-card>
      <el-card shadow="none" style="margin-top: 20px" class="order-content"
               v-for="brand in  dataInfo.batchInfoOrderList" :key="brand.id">

        <div class="order-content-header" slot="header">
          <span class="bold">{{ brand.tsStoreOrderInfo.brandName }}</span>
          <span>Order {{ brand.tsStoreOrderInfo.uid }}</span>
        </div>
        <div class="order-content-item" v-for="(item,index) in brand.orderDetailList" :key="index">
          <el-image :src="item.skuImg" class="img" fit="fill"/>
          <div class="item-con">
            <span class="bold">{{ item.skuName }}</span>
            <span style="padding-top: 4px"> {{item.skuParams}} <span style="color: #999999">{{ item.vdSku }}</span></span>
            <div class="item-bottom">
              <div class="item-bottom-item">
                <span>Items</span>
                <span>{{ item.qty }}</span>
              </div>
              <div class="item-bottom-item">
                <span>Wholesale Price</span>
                <span>${{ Number(item.price).toFixed(2) }}</span>
              </div>
              <div class="item-bottom-item">
                <span>Total</span>
                <span>${{ Number(item.total).toFixed(2) }}</span>
              </div>
              <div class="item-bottom-item">
                <span>Status</span>
                <span>{{ $tool.valueToLabel(item.orderStatus, orderStatusOptions) }}</span>
              </div>
            </div>
          </div>
        </div>
      </el-card>
      <div class="order-bottom">
        <div>
          <span class="bold">Payment method</span>
          <span>{{ dataInfo.batchInfoDetail.paymethodEnName }}</span>
        </div>
        <div class="bottom-right">
          <span class="bold">Order Summary</span>
          <div v-for="(order,index) in dataInfo.batchInfoOrderList" :key="index" class="bottom-right-block">
            <div class="item">
              <span>{{ order.tsStoreOrderInfo.brandName }}</span>
              <span>${{ Number(order.tsStoreOrderInfo.totalPriceBefore-order.tsStoreOrderInfo.productDiscounted).toFixed(2)}}</span>
            </div>
            <div class="item orange"
                 v-if="order.tsStoreOrderInfo.orderDiscounted && order.tsStoreOrderInfo.orderDiscounted> 0">
              <span>{{ order.tsStoreOrderInfo.brandName }} Discount</span>
              <span>-${{ Number(order.tsStoreOrderInfo.orderDiscounted).toFixed(2) }}</span>
            </div>
          </div>
          <el-divider/>
          <div class="item bold" style="margin-top: 5px">
            <span>Subtotal</span>
            <span>${{ Number(orderTotal['subTotal']).toFixed(2) }}</span>
          </div>
          <div class="bottom-right-block">
            <div class="item">
              <span>Shipping</span>
              <span>${{ Number(orderTotal['shipping']).toFixed(2) }}</span>
            </div>
            <div class="item orange" v-if="orderTotal['shippingDisc'] && orderTotal['shippingDisc'] > 0">
              <span>Shipping Discount(By Brand)</span>
              <span>-${{ Number(orderTotal['shippingDisc']).toFixed(2) }}</span>
            </div>
          </div>
          <el-divider/>
          <div class="item bold " style="margin-top: 5px">
            <span>Order Total</span>
            <span>${{ Number(dataInfo['batchInfoDetail']['payAmount']).toFixed(2) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getAction} from '@/api/manage.js'

import CustomBreadcrumb from '../components/custom-breadcrumb'
import Address from '../components/address'

export default {
  components: {CustomBreadcrumb, Address},
  data() {
    return {
      batchNo: '',
      loading: false,
      addressMessage: {},
      dataInfo: {},
      orderTotal: {
        subTotal: 0,
        shipping: 0,
        shippingDisc: 0
      },
      orderStatusOptions: [
        {label: 'Unpaid', value: 0},
        {label: 'Paid', value: 1},
        {label: 'Cancelled', value: 2},
        {label: 'Shipped', value: 3},
        {label: 'Partial Shipped', value: 4},
        {label: 'Received', value: 5},
        {label: 'Refund under review', value: 6},
        {label: 'Refunded', value: 7},
        {label: 'Declined on Refund', value: 8},
        {label: 'On Hold', value: 31},
        {label: 'Progressing', value: 10},
        {label: 'Partial refund', value: 9},
        {label: 'Failed', value: 11},
        {label: 'Returning', value: 13},
        {label: 'Return completed', value: 23},
        {label: 'Complete partially', value: 24},
        {label: 'Tranding closed', value: 99},
        {label: 'Packaging', value: 40},
        {label: 'Partial Delivered', value: 52},
        {label: 'Delivered', value: 53},
        {label: 'Partial Received', value: 54}
      ]
    }
  },
  created() {
    getAction('/sp/suppliers/categorys').then(res => {
      if (res.code === 200) {
        this.categoryList = res.result
      }
    })
    this.batchNo = this.$route.query.no
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      getAction(`/order/api/v0.2/batch-orders/${this.batchNo}`).then(response => {
        if (response.success) {
          this.dataInfo = response['result']
          this.dataInfo['batchInfoOrderList'].forEach(obj => {
            if (obj['tsStoreOrderInfo']['freightDiscounted'] && Number(obj['tsStoreOrderInfo']['freightDiscounted']) > 0) {
              this.orderTotal['shippingDisc'] += Number(obj['tsStoreOrderInfo']['freightDiscounted'])
            }
            if (obj['tsStoreOrderInfo']['totalFreightBefore'] && Number(obj['tsStoreOrderInfo']['totalFreightBefore']) > 0) {
              this.orderTotal['shipping'] += Number(obj['tsStoreOrderInfo']['totalFreightBefore'])
            }
            this.orderTotal['subTotal'] += (Number(obj['tsStoreOrderInfo']['totalPriceBefore']) - Number(obj['tsStoreOrderInfo']['productDiscounted']) - Number(obj['tsStoreOrderInfo']['orderDiscounted']))
          })
          this.orderTotal['subTotal'] -= Number(this.dataInfo['batchInfoDetail']['couponPrice'])
        } else {
          this.$message.warning(response.message)
        }
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-card__header {
  background: #F7F7F7;
}

.page_title {
  margin: 10px 30px 30px 0px !important;
}

.bold {
  font-weight: 700;
}

.border {
  height: 100px;
  width: 1px;
  border-right: 1px solid #cccccc;
}

.orange {
  color: #c3824b;
}

.gray {
  color: #5d5d5d
}

.order {
  width: 100%;
  font-size: 14px;
  font-family: Graphik;
  min-width: 1400px;

  &-header {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    white-space: nowrap;

    .address {
      display: flex;
      flex-direction: column;
    }

    &-item {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 0 100px 0 40px;
      min-width: 226px;

      span {
        margin-bottom: 2px;
      }
    }
  }

  &-content {

    &-header {
      display: flex;
      justify-content: space-between;

    }

    &-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      border-bottom: 1px solid #E1E1E1;
      padding-bottom: 20px;
      margin-bottom: 20px;

      .img {
        width: 100px;
        height: 100px;
        border: 1px solid #E1E1E1;
      }

      .item-con {
        padding-left: 10px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        .item-bottom {
          margin-top: 10px;
          display: flex;
          flex-direction: row;

          &-item {
            height: 40px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-right: 40px;

          }
        }
      }
    }

    &-item:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;
    }
  }

  &-bottom {
    margin-top: 20px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .bottom-right {
      width: 300px;

      &-block {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;

      }

      .item {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-top: 14px;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/vidirect/refer-orders-detail.vue